import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Button, screenSizeSmaller} from 'views/components';
import {Translate} from 'views/module';
import {Add} from 'views/icons';

import ContactBox from './ContactBoxEdit';

const FamilyContactsBox = (props) => {
  const {data, updateFormData} = props;

  const isMobile = screenSizeSmaller('md');

  const handleAddContact = () => {
    const newContact = {
      name: '',
      relationship: '',
      phoneNumber: '',
      email: '',
    };
    updateFormData('contacts', [...(data.contacts ?? []), newContact]);
  };

  return (
    <Box style={{background: 'white', borderRadius: '1rem', boxShadow: '0 1px 6px rgba(0,0,0,0.1)', padding: '1rem', position: 'relative'}}>
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem'}}>
        <Typography variant="h6">
          <Translate expression="profile.FamilyContactsBox.Title" />
        </Typography>
        <Button
          style={{background: '#3060d9', color: '#fff', borderRadius: 8, display: 'flex', alignItems: 'center', gap: 4}}
          onClick={handleAddContact}
        >
          <Add style={{color: '#fff', fontSize: 14}} />
          <span style={{fontSize: 12, textTransform: 'none', marginTop: 1}}><Translate expression="profile.FamilyContactsBox.AddContact" /></span>
        </Button>
      </Box>

      {/* Render contacts in rows of one if isMobile, otherwise in rows of two */}
      {
        Array.from({length: Math.ceil((data.contacts?.length ?? 0) / (isMobile ? 1 : 2))}).map((_, rowIdx) => (
          <Box key={rowIdx} sx={{display: 'flex', gap: '1rem', mb: '1rem'}}>
            {
              (isMobile ? [0] : [0, 1]).map((colIdx) => {
                const contactIdx = rowIdx * (isMobile ? 1 : 2) + colIdx;
                if (contactIdx < (data.contacts?.length ?? 0)) {
                  const contact = data.contacts?.[contactIdx];
                  return (
                    <Box key={contactIdx} sx={{flex: 1, minWidth: 0}}>
                      <ContactBox
                        data={contact}
                        onUpdate={(updatedContact) => {
                          const updatedContacts = data.contacts?.map((c, idx) => idx === contactIdx ? updatedContact : c);
                          updateFormData('contacts', updatedContacts);
                        }}
                        onDelete={() => {
                          const updatedContacts = data.contacts?.filter((_, idx) => idx !== contactIdx);
                          updateFormData('contacts', updatedContacts);
                        }}
                      />
                    </Box>
                  );
                } else {
                  // Fill empty space if odd number of contacts
                  return <Box key={contactIdx} sx={{flex: 1, minWidth: 0}} />;
                }
              })
            }
          </Box>
        ))
      }
    </Box>
  );
};

FamilyContactsBox.propTypes = {
  data: PropTypes.shape({
    contacts: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  updateFormData: PropTypes.func.isRequired,
};

export default FamilyContactsBox;
